import {
	creators,
	print,
	type Clause,
	type Jast,
	COMPOUND_OPERATOR_AND,
	OPERATOR_EQUALS,
	CLAUSE_TYPE_TERMINAL,
	OPERAND_TYPE_VALUE,
} from '@atlaskit/jql-ast';
import removeFieldClauseFromJql from '@atlassian/jira-jql-utils/src/utils/remove-field-clause.tsx';
import { escapeBackslashes } from '../../../../../common/utils.tsx';

const createTerminalClause = (fieldId: string, value: boolean) =>
	creators.terminalClause(
		creators.field(escapeBackslashes(fieldId)),
		creators.operator(OPERATOR_EQUALS),
		creators.byText.valueOperand(value ? '"true"' : '""'),
	);

export const getUpdatedJql = (
	ast: Jast,
	clause: Clause | undefined,
	fieldId: string,
	value: boolean,
): string => {
	const hasValue = Boolean(value);
	if (!clause) {
		if (!ast.query || !hasValue) {
			return ast.represents;
		}
		if (value) {
			ast.query.appendClause(createTerminalClause(fieldId, value), COMPOUND_OPERATOR_AND);
		}
	} else if (value) {
		clause.replace(createTerminalClause(fieldId, value));
	} else {
		return removeFieldClauseFromJql(ast, clause);
	}
	return print(ast, {
		operatorCase: 'upper',
	});
};

export const getInitialState = (clause: Clause | undefined): boolean =>
	(clause &&
		clause.clauseType === CLAUSE_TYPE_TERMINAL &&
		clause.operand &&
		clause.operand.operandType === OPERAND_TYPE_VALUE &&
		clause.operand.value) === 'true';
